import { useLocation, useParams } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { SubscriptionMultiPayment } from './SubscriptionMultiPayment'
import { SubscriptionSinglePayment } from './SubscriptionSinglePayment'

export const SubscriptionPaymentsCnt = () => {
  const params = useParams({ strict: false }) as { paymentId?: string, billingPeriodId?: string; subscriptionId?: string }
  const location = useLocation()
  const [jobId, setJobId] = useState<string | null>(new URLSearchParams(location.search as Record<string, string>).get('jobId'))

  useEffect(() => {
    const currentJobId = new URLSearchParams(location.search as Record<string, string>).get('jobId')
    setJobId(currentJobId)
  }, [location.search])

  if (params.paymentId && params.billingPeriodId && !jobId) {
    return <SubscriptionSinglePayment paymentId={params.paymentId} billingId={params.billingPeriodId} />
  }
  else if (params.paymentId && params.subscriptionId && !jobId) {
    return <SubscriptionMultiPayment paymentId={params.paymentId} subscriptionId={params.subscriptionId} />
  }

  return <>Error</>
}
